// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"b04363ee","220":"5ad42202","616":"6cacd5bd"}[chunkId] + ".chunk.js";
};